export default "__VITE_ASSET__KGMtwpsM__"